export const GET_GEONAMES = 'GET_GEONAMES';
export const GET_GEODATA = 'GET_GEODATA';
